import { Breadcrumb } from "@gull";
import queryString from "app/services/queryStringService";
import { useMemo, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { exportBookedFlight } from "app/services/AdminServices/bookingService";
import { MdOutlineRefresh, MdSearch } from "react-icons/md";
import moment from "moment";
import { AiFillFileExcel } from "react-icons/ai";
import MemberAutoComplete from "../Flight/Components/MemberAutoComplete";
import { NotificationManager } from "react-notifications";
import {
  exportReportFlight,
  REPORT_FIELDS,
} from "app/services/ReportListService";

export default function FlightBooking() {
  const [isShowGlobalFilter, setIsShowGlobalFilter] = useState(true);

  const initialFilters = {
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    fromDate: "",
    searchBy: "Booking",
    totalBookingAmount: null,
    agentValue: "",
    toDate: "",
    pnr: "",
    selectedValue: null,
    show: false,
    bookingStatus: "",
    depart: "",
    arrival: "",
    paxName: "",
  };

  const [filters, setFilters] = useState(initialFilters);

  const refreshFilter = () => {
    setFilters(initialFilters);
  };
  const handleSearch = async () => {
    setFilters((prev) => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      loading: true,
    }));

    // await loadBookingDetails();

    // setTimeout(() => {
    //   loadTotalAmount();
    // }, 100);
  };
  const handleSearchChanges = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const exportReport = async () => {
    debugger;
    if (selectedFields.length == 0)
      return NotificationManager.warning("Please Check minimum 1 Column");

    const columnArray = selectedFields.map((f) => f.propertyName);
    const query = queryString.getQueryStringFromObj({
      fromDate: filters.fromDate,
      SearchBy: filters.searchBy,
      toDate: filters.toDate,
      pnr: filters.pnr,
      agentValue: filters.agentValue,
      TransactionStatus: filters.bookingStatus,
      FromOrigin: filters.depart,
      ToDestination: filters.arrival,
      PassengerName: filters.paxName,
    });
    const req = {
      SelectedFields: columnArray,
    };

    if (filters.dataCount !== 0) {
      setFilters((prev) => ({
        ...prev,
        loading: true,
      }));
    }

    const response = await exportReportFlight(query, req);

    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_Flight_Booked_List.xlsx`,
      );

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setFilters((prev) => ({
      ...prev,
      loading: false,
    }));
  };

  const handleExport = async () => {
    setFilters((prev) => ({
      ...prev,
      page: prev.page,
      sizePerPage: prev.sizePerPage,
    }));

    setTimeout(async () => {
      await exportReport();
    }, 10);
  };
  const refreshGlobalFilter = async (e) => {
    setIsShowGlobalFilter(!isShowGlobalFilter);
  };
  // Sort fields by order
  const sortedFields = useMemo(
    () => [...REPORT_FIELDS].sort((a, b) => a.order - b.order),
    [],
  );

  // State management
  const [availableFields, setAvailableFields] = useState(sortedFields);
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectedFromAvailable, setSelectedFromAvailable] = useState(new Set());
  const [selectedFromSelected, setSelectedFromSelected] = useState(new Set());

  // Toggle selection in available list
  const toggleAvailableSelection = (field) => {
    const newSet = new Set(selectedFromAvailable);
    if (newSet.has(field.propertyName)) {
      newSet.delete(field.propertyName);
    } else {
      newSet.add(field.propertyName);
    }
    setSelectedFromAvailable(newSet);
  };

  // Toggle selection in selected list
  const toggleSelectedSelection = (field) => {
    const newSet = new Set(selectedFromSelected);
    if (newSet.has(field.propertyName)) {
      newSet.delete(field.propertyName);
    } else {
      newSet.add(field.propertyName);
    }
    setSelectedFromSelected(newSet);
  };

  // Move from available to selected
  const moveToSelected = () => {
    const fieldsToMove = availableFields.filter((f) =>
      selectedFromAvailable.has(f.propertyName),
    );
    setSelectedFields(
      [...selectedFields, ...fieldsToMove].sort((a, b) => a.order - b.order),
    );
    setAvailableFields(
      availableFields.filter((f) => !selectedFromAvailable.has(f.propertyName)),
    );
    setSelectedFromAvailable(new Set());
  };

  // Move from selected back to available
  const moveToAvailable = () => {
    const fieldsToMove = selectedFields.filter((f) =>
      selectedFromSelected.has(f.propertyName),
    );
    setAvailableFields(
      [...availableFields, ...fieldsToMove].sort((a, b) => a.order - b.order),
    );
    setSelectedFields(
      selectedFields.filter((f) => !selectedFromSelected.has(f.propertyName)),
    );
    setSelectedFromSelected(new Set());
  };

  // Select/Deselect all
  const selectAllAvailable = () => {
    if (selectedFromAvailable.size === availableFields.length) {
      setSelectedFromAvailable(new Set());
    } else {
      setSelectedFromAvailable(
        new Set(availableFields.map((f) => f.propertyName)),
      );
    }
  };

  const selectAllSelected = () => {
    if (selectedFromSelected.size === selectedFields.length) {
      setSelectedFromSelected(new Set());
    } else {
      setSelectedFromSelected(
        new Set(selectedFields.map((f) => f.propertyName)),
      );
    }
  };

  // Handle submit - prepare API payload
  const handleSubmit = () => {
    const columnArray = selectedFields.map((f) => ({
      displayName: f.displayName,
      propertyName: f.propertyName,
      order: f.order,
    }));

    console.log("Columns to send to API:", columnArray);
    console.log("JSON Payload:", JSON.stringify(columnArray, null, 2));

    // Example API call:
    // const response = await fetch('/api/report/download', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({
    //     selectedColumns: columnArray,
    //     // ... other report parameters
    //   })
    // });

    alert(
      "Selected columns sent to console. Check browser console for details.",
    );
  };

  const handleReset = () => {
    setAvailableFields(sortedFields);
    setSelectedFields([]);
    setSelectedFromAvailable(new Set());
    setSelectedFromSelected(new Set());
  };

  return (
    <>
      <Helmet>
        <title>Booking History</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[
          {
            name: (
              <div>
                <div>Flight Booking Customize Report</div>
                <h5
                  className="text-muted"
                  style={{
                    fontWeight: 400,
                    marginTop: 5,
                    marginBottom: -5,
                    fontSize: 13,
                  }}
                >
                  Choose which fields to include in your report download
                </h5>
              </div>
            ),
          },
        ]}
      ></Breadcrumb>

      {/* Dual List Selector */}
      <div className="bookingList-header" style={{ marginBottom: 20 }}>
        <Row>
          {/* <Row className="align-items-center mb-2">
            <Col className="col-md-12 d-flex justify-content-end mt-1">
              <Button
                variant="primary"
                className="mx-2"
                onClick={refreshGlobalFilter}
              >
                {isShowGlobalFilter ? (
                  <>
                    Filter <i className="i-Filter-2 mt-1" />
                  </>
                ) : (
                  <i className="i-Filter-2 mt-1" />
                )}
              </Button>

              <Button
                variant="primary"
                onClick={handleExport}
                disabled={!filters.dataCount}
              >
                {isShowGlobalFilter ? (
                  <>
                    Export <AiFillFileExcel size={15} />
                  </>
                ) : (
                  <AiFillFileExcel size={15} />
                )}
              </Button>
            </Col>
          </Row> */}
          <div
          // className={isShowGlobalFilter ? "collapse" : "show"}
          >
            <div className="card card-body rounded border mb-1">
              <Row>
                {/* Search By */}
                <Col md={2} col={12}>
                  <label>Search By</label>
                  <select
                    className="form-select"
                    name="SearchBy"
                    value={filters.SearchBy}
                    onChange={handleSearchChanges}
                  >
                    <option value="Booking">Booking</option>
                    <option value="Travel">Travel</option>
                    <option value="Issue_Date">Issue Date</option>
                  </select>
                </Col>
                {/* Date From */}
                <Col md={2} col={12}>
                  <label>Date From</label>
                  <input
                    type="date"
                    className="form-control"
                    name="fromDate"
                    value={filters.fromDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </Col>
                {/* Date To */}
                <Col md={2} col={12}>
                  <label>Date To</label>
                  <input
                    type="date"
                    className="form-control"
                    name="toDate"
                    value={filters.toDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </Col>
                {/* PNR */}
                <Col md={2} col={12}>
                  <label>PNR</label>
                  <input
                    type="text"
                    className="form-control"
                    name="pnr"
                    placeholder="PNR"
                    value={filters.pnr}
                    onChange={handleSearchChanges}
                  />
                </Col>
                {/* Agency */}
                {/* <Col md={2} col={12}>
                  <label>Agency</label>
                  <MemberAutoComplete
                    selectedValue={filters.}
                    setSelectedValue={setFilters}
                    name="agentValue"
                    setState={setFilters}
                  />
                  {filters.selectedValue}
                </Col> */}
                {/* Booking Status */}
                <Col md={2} col={12}>
                  <label>Booking Status</label>
                  <select
                    className="form-select"
                    name="bookingStatus"
                    value={filters.bookingStatus}
                    onChange={handleSearchChanges}
                  >
                    <option value="">Select option</option>
                    <option value="Completed">Completed</option>
                    <option value="Pending">Pending</option>
                    <option value="Refund">Refund</option>
                    <option value="Partial Cancelled">
                      Partial Cancellation
                    </option>
                    <option value="Fully Cancelled">Fully Cancellation</option>
                    <option value="Hold">Hold</option>
                    <option value="Unconfirmed">Unconfirmed</option>
                  </select>
                </Col>
                {/* Depart */}
                {/* <Col md={2} col={12}>
                  <label>Origin (From)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="depart"
                    placeholder="Origin (From)"
                    value={filters.depart}
                    onChange={handleSearchChanges}
                  />
                </Col>{" "} */}
                {/* Arrival */}
                {/* <Col md={2} col={12}>
                  <label>Destination (To)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="arrival"
                    placeholder="Destination (To)"
                    value={filters.arrival}
                    onChange={handleSearchChanges}
                  />
                </Col>{" "} */}
                {/* PNR */}
                {/* <Col md={2} col={12}>
                  <label>Pax Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="paxName"
                    placeholder="Pax Name"
                    value={filters.paxName}
                    onChange={handleSearchChanges}
                  />
                </Col> */}
                {/* Action Buttons */}
                <Col
                  md={2}
                  col={12}
                  className="d-flex justify-content-end mt-3"
                >
                  <button
                    className="btn btn-outline-primary me-2"
                    onClick={handleSearch}
                  >
                    <MdSearch size={18} />
                  </button>

                  <button
                    className="btn btn-outline-primary  me-2"
                    onClick={refreshFilter}
                  >
                    <MdOutlineRefresh size={18} />
                  </button>
                  <button
                    // variant="primary"
                    className="btn btn-outline-primary"
                    onClick={handleExport}
                  >
                    <AiFillFileExcel size={18} />
                    {/* )} */}
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Row>
      </div>

      <Row className="g-2 mb-2">
        {/* Available Fields */}
        <Col lg={5}>
          <Card className="h-100 shadow-lg">
            <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center py-2">
              <h5 className="mb-0 fw-bold text-white">Available Fields</h5>
              <Button
                size="sm"
                variant="light"
                className="text-dark fw-bold"
                onClick={selectAllAvailable}
              >
                {selectedFromAvailable.size === availableFields.length
                  ? "Deselect All"
                  : "Select All"}
              </Button>
            </Card.Header>
            <Card.Body
              className="p-0"
              style={{ maxHeight: "450px", overflowY: "auto" }}
            >
              {availableFields.length === 0 ? (
                <div className="p-4 text-center text-muted">
                  <p className="mb-0">No fields available</p>
                  <small>All fields have been selected</small>
                </div>
              ) : (
                availableFields.map((field) => (
                  <div
                    key={field.propertyName}
                    className="d-flex align-items-center p-3 border-bottom"
                    style={{
                      backgroundColor: selectedFromAvailable.has(
                        field.propertyName,
                      )
                        ? "#e7f3ff"
                        : "transparent",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onClick={() => toggleAvailableSelection(field)}
                  >
                    <Form.Check
                      type="checkbox"
                      id={`avail-${field.propertyName}`}
                      checked={selectedFromAvailable.has(field.propertyName)}
                      onChange={() => toggleAvailableSelection(field)}
                      className="me-3"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="flex-grow-1">
                      <div className="fw-500 text-dark">
                        {field.displayName}
                      </div>
                      {/* <small className="text-muted">{field.propertyName}</small> */}
                    </div>
                  </div>
                ))
              )}
            </Card.Body>
            <Card.Footer className="bg-light p-2">
              <Button
                variant="primary"
                size="sm"
                className="w-100 fw-bold"
                onClick={moveToSelected}
                disabled={selectedFromAvailable.size === 0}
              >
                ← Include Selected
              </Button>
            </Card.Footer>
          </Card>
        </Col>

        {/* Center Control Buttons */}
        <Col lg={2} className="d-flex flex-column justify-content-center gap-2">
          <Button
            variant="primary"
            size="sm"
            onClick={moveToSelected}
            disabled={selectedFromAvailable.size === 0}
            className="fw-bold py-2"
          >
            Add →
          </Button>
          <Button
            variant="secondary"
            size="sm"
            className="fw-bold px-4"
            onClick={handleReset}
          >
            Reset Fields
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={moveToAvailable}
            disabled={selectedFromSelected.size === 0}
            className="fw-bold py-2 text-white"
          >
            ← Remove
          </Button>
        </Col>

        {/* Selected Fields */}
        <Col lg={5}>
          <Card className="h-100 shadow-lg">
            <Card.Header className="bg-success text-white d-flex justify-content-between align-items-center py-2">
              <h5 className="mb-0 fw-bold text-white">
                Selected Fields ({selectedFields.length})
              </h5>
              <Button
                size="sm"
                variant="light"
                className="text-dark fw-bold"
                onClick={selectAllSelected}
              >
                {selectedFromSelected.size === selectedFields.length
                  ? "Deselect All"
                  : "Select All"}
              </Button>
            </Card.Header>
            <Card.Body
              className="p-0"
              style={{ maxHeight: "450px", overflowY: "auto" }}
            >
              {selectedFields.length === 0 ? (
                <div className="p-4 text-center text-muted">
                  <p className="mb-0">No fields selected</p>
                  <small>Select fields from the left to add them</small>
                </div>
              ) : (
                selectedFields.map((field) => (
                  <div
                    key={field.propertyName}
                    className="d-flex align-items-center p-3 border-bottom"
                    style={{
                      backgroundColor: selectedFromSelected.has(
                        field.propertyName,
                      )
                        ? "#f0f8e7"
                        : "transparent",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onClick={() => toggleSelectedSelection(field)}
                  >
                    <Form.Check
                      type="checkbox"
                      id={`sel-${field.propertyName}`}
                      checked={selectedFromSelected.has(field.propertyName)}
                      onChange={() => toggleSelectedSelection(field)}
                      className="me-3"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="flex-grow-1">
                      <div className="fw-500 text-dark">
                        {field.displayName}
                      </div>
                      {/* <small className="text-muted">{field.propertyName}</small> */}
                    </div>
                    {/* <small className="badge bg-info text-dark">
                      {field.order}
                    </small> */}
                  </div>
                ))
              )}
            </Card.Body>
            <Card.Footer className="bg-light p-2">
              <Button
                variant="danger"
                size="sm"
                className="w-100 fw-bold"
                onClick={moveToAvailable}
                disabled={selectedFromSelected.size === 0}
              >
                Remove Selected →
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      {/* Debug Info - Show selected columns array */}
      {/* {selectedFields.length > 0 && (
        <Row className="mt-4">
          <Col>
            <Card className="bg-light">
              <Card.Header className="bg-secondary text-white fw-bold">
                API Payload Preview (Selected Columns)
              </Card.Header>
              <Card.Body>
                <pre
                  style={{
                    fontSize: "12px",
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  {JSON.stringify(
                    selectedFields.map((f) => ({
                      displayName: f.displayName,
                      propertyName: f.propertyName,
                      order: f.order,
                    })),
                    null,
                    2,
                  )}
                </pre>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )} */}
    </>
  );
}
